<div class="main-sidebar flush-menu">
    <div class="main-menu">
        <ul class="sidebar-menu list-unstyled scrollable ps-0">
            <li class="sidebar-item mb-0">
                <ul class="sidebar-link-group">
                    <li class="sidebar-dropdown-item">
                        <a href="/dashboard" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-object-group"></i></span> <span class="sidebar-txt">Dashboard</span></a>
                    </li>
                </ul>
            </li>
            <li class="sidebar-item">
                <!-- <a role="button" class="sidebar-link-group-title has-sub">Apps</a> -->
                <ul class="sidebar-link-group">
                    <li class="sidebar-dropdown-item">
                        <a href="/all-customers" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-user-group"></i></span> <span class="sidebar-txt">All Customer</span></a>
                    </li>
                    <li class="sidebar-dropdown-item">
                        <a href="/add-product" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-plus-square"></i></span> <span class="sidebar-txt">Add Product</span></a>
                    </li>
                    <li class="sidebar-dropdown-item">
                        <a href="/all-products" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-boxes"></i></span> <span class="sidebar-txt">All Product</span></a>
                    </li>
                    <li class="sidebar-dropdown-item">
                        <a href="/category" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-tag"></i></span> <span class="sidebar-txt">Category</span></a>
                    </li>
                    <li class="sidebar-dropdown-item">
                        <a href="/attributes" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-list-check"></i></span> <span class="sidebar-txt">Attributes</span></a>
                    </li>
                    <li class="sidebar-dropdown-item">
                        <a class="sidebar-link text-decoration-none" data-bs-toggle="collapse" href="#collapseOrder" role="button" aria-expanded="false" aria-controls="collapseOrder"><span class="nav-icon"><i class="fa fa-cart-shopping"></i></span> <span class="sidebar-txt">Order</span></a>
                        <ul class="sidebar-link-group collapse ps-4" id="collapseOrder">
                            <li class="sidebar-dropdown-item">
                                <a href="/orders" class="sidebar-link text-decoration-none p-1"><span class="sidebar-txt">Order List</span></a>
                            </li>
                            <li class="sidebar-dropdown-item">
                                <a href="/cod-refund-requests" class="sidebar-link text-decoration-none p-1"><span class="sidebar-txt">Refund Requests</span></a>
                            </li>
                        </ul>
                    </li>
                     <li class="sidebar-dropdown-item">
                        <a href="/coupons" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-gift"></i></span> <span class="sidebar-txt">Coupons</span></a>
                    </li>
                      <li class="sidebar-dropdown-item">
                        <a href="/settings" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class=" fa fa-gear"></i></span> <span class="sidebar-txt">Settings</span></a>
                    </li>

                      <li class="sidebar-dropdown-item">
                        <a href="/pages" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class=" fa fa-file"></i></span> <span class="sidebar-txt">Pages</span></a>
                    </li>
                     <li class="sidebar-dropdown-item">
                        <a href="/reports" class="sidebar-link text-decoration-none"><span class="nav-icon"><i class="fa fa-chart-bar"></i></span> <span class="sidebar-txt">Reports</span></a>
                    </li>

                    

                    
                    <!-- <li class="sidebar-dropdown-item">
                        <a href="order.html" class="sidebar-link"><span class="nav-icon"><i class="fa fa-cart-shopping"></i></span> <span class="sidebar-txt">Attributes</span></a>
                    </li>
                    <li class="sidebar-dropdown-item">
                        <a href="order.html" class="sidebar-link"><span class="nav-icon"><i class="fa fa-cart-shopping"></i></span> <span class="sidebar-txt">Coupon</span></a>
                    </li>
                    <li class="d-none sidebar-dropdown-item">
                        <a href="calendar.html" class="sidebar-link"><span class="nav-icon"><i class="fa fa-calendar"></i></span> <span class="sidebar-txt">Calendar</span></a>
                    </li>
                    <li class="d-none sidebar-dropdown-item">
                        <a href="invoices.html" class="sidebar-link"><span class="nav-icon"><i class="fa fa-file-invoice"></i></span> <span class="sidebar-txt">Invoices</span></a>
                    </li>
                    <li class="d-none sidebar-dropdown-item">
                        <a href="contact.html" class="sidebar-link"><span class="nav-icon"><i class="fa fa-user-plus"></i></span> <span class="sidebar-txt">Contacts</span></a>
                    </li> -->
                </ul>
            </li>
        </ul>
    </div>
</div>